import { IMAGES } from "@/lib/content";

export const Hero = () => (
  <section className="bg-sage text-pine pb-24 md:pb-32 pt-8" data-testid="hero-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[1.1fr_1fr] gap-12 items-center">
      <div className="min-w-0">
        <p className="lb text-brass-ink fu">A faith-based ministry for military couples</p>
        <h1 className="dp mt-6" data-testid="hero-headline">
          <span className="ln"><span>Hold fast</span></span>
          <span className="ln"><span><em>through every move.</em></span></span>
        </h1>
        <p className="mt-6 max-w-md fu s1 text-moss" data-testid="hero-differentiator">
          We've lived deployment and PCS stress, and offer confidential, judgment-free care.
        </p>
        <div className="mt-8 flex flex-wrap gap-6 items-center fu s2">
          <a
            href="#book"
            className="group bg-pine text-sage rounded-full px-7 py-4 transition-colors hover:bg-pine-soft"
            data-testid="hero-book-button"
          >
            Book a time slot <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </a>
          <a
            href="#donate"
            className="underline underline-offset-4 decoration-brass hover:text-brass-ink transition-colors"
            data-testid="hero-donate-link"
          >
            Donate
          </a>
        </div>
      </div>
      <div className="tilt fu s3">
        <div>
          <figure className="wp relative aspect-[4/5] rounded-t-[200px] overflow-hidden bg-mist-1">
            <img
              src={IMAGES.hero}
              alt="A military couple embracing at a homecoming"
              className="absolute inset-0 h-full w-full object-cover"
              data-testid="hero-image"
            />
            <figcaption className="absolute bottom-6 left-6 lb bg-sage/90 text-moss px-3 py-1.5 rounded-full">
              Homecoming embrace
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </section>
);
